// extracted by mini-css-extract-plugin
export default {"backdrop":"Popup_backdrop__g8xnW","wrap_popup":"Popup_wrap_popup__L+axi"};